export default function WhoItsFor() {
  const businesses = [
    'Contractors',
    'Home Services',
    'Cleaning Companies',
    'Repair Professionals',
    'Local Service Providers'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          Built For Long Island Service Businesses
        </h2>

        <div className="flex flex-wrap justify-center gap-4 mt-12">
          {businesses.map((business, index) => (
            <div 
              key={index}
              className="bg-teal-50 text-teal-700 px-8 py-4 rounded-full text-lg font-medium"
            >
              {business}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
